import React, {Suspense} from 'react';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import MileageMidRegister from '@di-shared/features/mileage/mid-register/MileageMidRegister';

interface MileageMidRegisterPageProps {
  vin: string;
}

function MileageMidRegisterPage({vin}: MileageMidRegisterPageProps) {
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Suspense fallback={<MileageMidRegister.Loading />}>
        <MileageMidRegister vin={vin} />
      </Suspense>
    </div>
  );
}

export default MileageMidRegisterPage;
